package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_12_28_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes continue their journey. They are now in “the desert proper.” The heroes leave the road and head towards Well’s Bounty. The number of birds and animals declines as they travel further into the desert.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday and Falorn spot something shiny. The heroes move closer to investigate. The shiny object is a gargantuan scorpion with silver metallic colored chitin.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday hastens Bigglesworth and Caper. Bigglesworth bravely sprints with unbelievable speed toward the scorpion and strikes the first blow. The scorpion appears to be alerting other scorpions, and the heroes see spikes appearing all over the silvery carapace of the giant beast.  Three other gargantuan scorpions crawl out of the sand nearby. While Bigglesworth impressed everyone with his bravery and speed, he is now outnumbered, suffers some gruesome blows, and is snatched up by the beast’s massive pincer. Goram runs to Bigglesworth’s aid, opening up a large space for Tuesday to launch an airstrike of fireball. Bigglesworth falls in combat.")
    }
}
